import { ShieldCheck, Sparkles, CreditCard, MapPin } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { useLang } from "@/i18n";

const ICONS = [ShieldCheck, Sparkles, CreditCard, MapPin];

export const WhyUs = () => {
  const { t } = useLang();
  const w = t.whyus;

  return (
    <section className="mx-auto max-w-7xl px-5 py-28 sm:px-8">
      <SectionHeading eyebrow={w.eyebrow} title={w.title} accent={w.accent} />
      <div className="grid gap-5 sm:grid-cols-2">
        {w.items.map((p, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={i} delay={i * 0.08}>
              <div
                data-testid={`whyus-card-${i}`}
                className="group h-full rounded-3xl border border-white/10 bg-[#0F0F14] p-8 transition-all duration-500 hover:-translate-y-1 hover:border-amber-400/40"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl border border-amber-400/30 bg-amber-400/10 transition-transform duration-500 group-hover:scale-110">
                  <Icon className="h-6 w-6 text-amber-400" />
                </div>
                <h3 className="mt-6 font-display text-xl font-bold text-white">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400">{p.desc}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};
